export const SUPPRESSED_ROUTES = [
    '/checkouts',
    '/cart',
    '/coming-soon'
];

export const SUPPRESSED_KEYWORDS = [
    '20p',
    '10p',
    'attentive',
    'attntest',
    '/checkouts',
    '/cart',
    '/coming-soon',
    'applovin',
    'freeship'
];

export const SUPPRESSED_QUERY_PARAMS = [
    'birthdate'
];
